import { Translation } from "src/components";

export const renderMessage = (
  message: string,
  configuration?: Record<string, unknown>,
): string =>
  (
    <Translation i18nKey={message} values={{ ...configuration }} />
  ) as unknown as string;
